export class DateModel {
  start_at: string | null = null;
  end_at: string | null = null;
}
